import store from '@/store'
import { extractRoleCode, getHomeRouteByRoleCode } from '@/config/roles'

export default async (_to, _from, next) => {
  const user = store.getters['auth/user']
  const userType = store.getters['auth/userType']
  const roleCode = extractRoleCode(user)

  if (user?.must_change_password) {
    next({ name: userType === 'student' ? 'student.force-password-change' : 'shared.force-password-change' })
  } else if (roleCode) {
    next({ name: getHomeRouteByRoleCode(roleCode) })
  } else {
    next()
  }
}
